module.exports = __webpack_public_path__ + "img/GoogleIcon.ce28d173.png";